import { FC } from 'react'
import { AttorneysSharingData } from "src/dtos/applicationData"
import {
  FlexDiv,
  ClaimItemFormMainContainer,
  ClaimItemFormSection,
  ClaimItemTitle,
  FormInputTitle,
  FormItemSubtitle
} from './styles'
import StandardInput from '../../basic/StandardInput'
import StepBullet from '../../basic/StepBullet'
import StandardFormatInput from '../../../components/basic/StandardFormatInput'
import { validateDateField } from 'src/utils/formDataManipulation'
import BarCardNumberInput from 'src/components/basic/BarCardNumberInput'

interface SharedExpenseAttorneyItemFormProps {
  sharedExpenseAttorney: AttorneysSharingData;
  itemIndex: number;
  setSharedExpenseAttorney: (data: Partial<AttorneysSharingData>) => void;
  isIncorrect?: boolean;
  errorCode?: string;
}

const SharedExpenseAttorneyItemForm: FC<SharedExpenseAttorneyItemFormProps> = ({ sharedExpenseAttorney, itemIndex, setSharedExpenseAttorney, isIncorrect, errorCode = '' }) => {
  return (
    <FlexDiv gap="18px" margin="0px 0px 0px 24px">
      <ClaimItemFormMainContainer>
        <ClaimItemTitle>
          <h3>Office Sharing Arrangement {itemIndex + 1}</h3>
          <hr />
        </ClaimItemTitle>
        <FlexDiv gap="24px" dir='column'>
          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet isComplete={sharedExpenseAttorney?.fullName !== undefined && sharedExpenseAttorney?.fullName.length > 0}>1</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FormInputTitle>Attorney or Law Firm name</FormInputTitle>
              <FlexDiv maxWidth='440px'>
                <StandardInput
                  label=""
                  value={sharedExpenseAttorney?.fullName ?? ''}
                  onChange={e => setSharedExpenseAttorney({ fullName: e.target.value })}
                  isIncorrect={isIncorrect && !sharedExpenseAttorney?.fullName}
                  errorMessage={isIncorrect && !sharedExpenseAttorney?.fullName ? 'This is a required field' : ''}
                  errorCode={`${errorCode}:${itemIndex}`}
                />
              </FlexDiv>
            </FlexDiv>
          </ClaimItemFormSection>

          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet isComplete={sharedExpenseAttorney?.barCardNumber !== undefined && (sharedExpenseAttorney?.barCardNumber?.length ?? 0) > 0}>2</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FlexDiv maxWidth='440px'>
                <BarCardNumberInput
                  label="Other Attorney Bar Number"
                  onChange={e => setSharedExpenseAttorney({ barCardNumber: e.target.value })}
                  value={sharedExpenseAttorney?.barCardNumber ?? ''}                  
                />
              </FlexDiv>
            </FlexDiv>
          </ClaimItemFormSection>

          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet isComplete={!isIncorrect && !validateDateField(sharedExpenseAttorney?.dateSharingBegan ?? '')}>3</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FormInputTitle>Date sharing began</FormInputTitle>
              <FormItemSubtitle>If exact date is unknown, please provide best estimate</FormItemSubtitle>
              <FlexDiv maxWidth='440px'>
                <StandardFormatInput
                  label=""
                  labelSize='high'
                  maskStyle='date'
                  value={sharedExpenseAttorney?.dateSharingBegan ?? ''}
                  onValueChange={({ formattedValue }) => setSharedExpenseAttorney({ dateSharingBegan: formattedValue })}
                  isIncorrect={isIncorrect && !sharedExpenseAttorney?.dateSharingBegan}
                  errorMessage={isIncorrect ? validateDateField(sharedExpenseAttorney?.dateSharingBegan) : ''}
                />
              </FlexDiv>
            </FlexDiv>
          </ClaimItemFormSection>
        </FlexDiv>
      </ClaimItemFormMainContainer>
    </FlexDiv>
  )
}

export default SharedExpenseAttorneyItemForm